import { render, staticRenderFns } from "./editCube3info.vue?vue&type=template&id=5c8d4722&scoped=true&"
import script from "./editCube3info.vue?vue&type=script&lang=js&"
export * from "./editCube3info.vue?vue&type=script&lang=js&"
import style0 from "./editCube3info.vue?vue&type=style&index=0&id=5c8d4722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d4722",
  null
  
)

export default component.exports